module.exports = __webpack_public_path__ + "static/media/S3N9-2.a7af9d30.svg";